module.exports = __webpack_public_path__ + "img/jsfny1.ff2e5090.png";